import { Form, field, required } from "lib/form";

export default class AddTagForm extends Form {
  @field("Name")
  @required()
  public name: string;

  @field("Major Id")
  @required()
  public majorId: number;
}
